<template>
    <v-dialog
        max-width="400px"
        persistent
        v-model="openDialog">
        <template v-slot:activator="{ on }">
            <slot :on="on" name="open"></slot>
        </template>
        <v-card color="white">
            <v-card-title>
                Abmelden
            </v-card-title>
            <v-card-text class="pb-2">
                <div class="mt-4">
                    Sind Sie sicher, dass Sie sich abmelden wollen?
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="logout" text>Abmelden</v-btn>
                <v-btn @click="openDialog = false" text>Abbrechen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LogoutDialog extends Vue {
    openDialog: boolean = false;

    logout(): void {
        localStorage.setItem('Auth/userConfig','');
        this.$store.commit("Auth/setAuthToken",'');
        this.$store.commit("Base/setCaller", "");
        this.$ports.auth.logout();
    }
}
</script>

<style scoped>

</style>
